import { render, staticRenderFns } from "./my-message-tip.vue?vue&type=template&id=97bee7d4&scoped=true"
import script from "./my-message-tip.vue?vue&type=script&lang=js"
export * from "./my-message-tip.vue?vue&type=script&lang=js"
import style0 from "./my-message-tip.vue?vue&type=style&index=0&id=97bee7d4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97bee7d4",
  null
  
)

export default component.exports